import { useSelector } from 'react-redux';

const useActiveNotificationChannel = () => {
  const { orgConfig } = useSelector((state: any) => state.user);

  const isNotificationChannelActive = (type: string, channel: string) => {
    const isActive = !!orgConfig?.notification_config?.filter(
      (item: any) => item.workflow_type === type
    )?.[0]?.[channel];
    return isActive;
  };

  return {
    isNotificationChannelActive
  };
};

export default useActiveNotificationChannel;
